import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-button",
    templateUrl: "./button.component.html"
})
export class FUIButtonComponent {
    @Input() @HostBinding("class.disabled") disabled: boolean;
    @Input() public title: string;

    constructor() {
    }
}
